import { makeStyles } from "@material-ui/core/styles";
//import blog from "../../images/memories2.jpg";
import { deepPurple } from "@material-ui/core/colors";

export default makeStyles((theme) => ({
  appBar: {
    borderRadius: 15,
    margin: "30px 0",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px 50px",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
    //backgroundImage: `url(${image})`,
    backgroundColor: "#EDEDED",
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    boxShadow: "10px 10px 20px rgba(0, 0, 0, 0.25)",
  },
  heading: {
    //color: "#FFFFFF",
    color: "#565656",
    fontWeight: 600,
    textDecoration: "none",
    webkitTransition: "all 0.3s ease",
    oTransition: "all 0.3s ease",
    transition: "all 0.3s ease",
    fontFamily: "merriweather",
    "&:hover": {
      webkitTransform: "translate(10px, -10px)",
      msTransform: "translate(10px, -10px)",
      transform: "translate(5px, -5px)",
      webkitBoxShadow: "0 20px 40px rgba(0, 0, 0, 0.08)",
      color: "#677f92",
    },
  },
  image: {
    marginLeft: "15px",
  },
  link: {
    textDecoration: "none",
    color: "inherit",
  },
  toolbar: {
    display: "flex",
    justifyContent: "flex-end",
    width: "400px",
    [theme.breakpoints.down("sm")]: {
      width: "auto",
    },
  },
  profile: {
    display: "flex",
    justifyContent: "space-between",
    width: "400px",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      width: "auto",
      marginTop: 20,
      justifyContent: "center",
    },
  },
  userName: {
    color: "#565656",
    display: "flex",
    alignItems: "center",
    textAlign: "center",
    fontFamily: "merriweather",
    fontWeight: 600,
    margin: "0 20px 0 10px",
  },
  brandContainer: {
    display: "flex",
    alignItems: "center",
  },
  purple: {
    color: theme.palette.getContrastText(deepPurple[500]),
    backgroundColor: deepPurple[500],
  },
}));
